import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import '@styles/main.less';

import PropertyList from './Properties';
import CreateProperty from './CreateProperty';
import ViewProperty from './ViewProperty';

function PropertiesPage(props) {
  const {
    match: { url }
  } = props;

  return (
    <Switch>
      <Route exact path={`${url}/`} component={PropertyList} />
      <Route exact path={`${url}/create`} component={CreateProperty} />
      <Route path={`${url}/:id/`} component={ViewProperty} />
    </Switch>
  );
}

PropertiesPage.propTypes = {
  match: PropTypes.object
};

export default PropertiesPage;
